

import React, { useState } from "react"
const Operator = (props) => {

    return (
        <React.Fragment>
            <div className="row bg-white border py-1">
                <div className="col" style={{ fontSize: "0.7rem", fontWeight: "bold" }}>

                    <p className="text-info m-0 text-center">
                        <span className="text-danger">
                            انبارگردانی دوم
                        </span>
                        <br />

                        <span>
                            اپراتور :
                        </span>
                        <span>
                            {props.operatorTwo}
                        </span>
                        <br />
                        <span>
                            تعداد شمارش  :
                        </span>
                        <span>
                            {props.stockTwo}
                        </span>
                    </p>
                </div>
                <div className="col" style={{ fontSize: "0.7rem", fontWeight: "bolder" }}>
                    <p className="text-info m-0 text-center">
                        <span className="text-danger">

                            انبارگردانی اول
                        </span>

                        <br />

                        <span>
                            اپراتور :
                        </span>
                        <span>
                            {props.operatorOne}
                        </span>
                        <br />
                        <span>
                            تعداد شمارش  :
                        </span>
                        <span>
                            {props.stockOne}
                        </span>
                    </p>
                </div>
                <div className="col" style={{ fontSize: "0.7rem", fontWeight: "bold" }}>
                    <p className="text-info m-0 text-center">
                        <span>
                            موجودی :
                        </span>
                        <span>
                            {props.stock}
                        </span>
                    </p>
                </div>
            </div>
        </React.Fragment>
    )
}
export default Operator;

